// extracted by mini-css-extract-plugin
export default {"Root":"zxSxdVFi","spin":"XMqBfdXm","Loading":"r9UhLWqU"};